<template>
  <header class="master-header-component">
    <slideshow class="slideshow" :images="['img1.jpg', 'img2.jpg', 'img3.jpg']" :height="640"/>
    <site-menu theme="light" class="menu"/>
    <div class="banner">
      <div class="line-1">
        Join researchers, policymakers, government agencies,<br/>
        business leaders &amp; industry experts at this year's symposium as we explore the theme:<br/>
      </div>
      <div class="line-2">CANNABIS BEST PRACTICES AND POLICY BARRIERS</div>
      <div class="dates">
        <span>U.S. Capitol Visitor Center<br/>Washington, D.C.<br/>April 10 - 12th, 2019</span>
      </div>
    </div>
  </header>
</template>
<script>
  import SiteMenu from '@/components/SiteMenu.vue'
  import Slideshow from '@/components/Slideshow.vue'

  export default {
    name: "master-header-component",
    components: { SiteMenu, Slideshow },
  }
</script>
<style lang="scss" scoped>
  .master-header-component {
    position: relative;
  }
  .menu {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
  }
  .banner {
    color: #fff;
    position: absolute;
    top: 180px;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.4);
    padding: 30px 0;
    text-align: center;
    font-size: 25px;
    z-index: 50;
    .line-2 {
      font-size: 40px;
      margin-top: 20px;
      font-weight: bold;
    }
  }
  .dates {
    margin-top: 20px;
    text-align: center;
    span {
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      text-shadow: 0 0 10px #000;
      padding-bottom: 20px;
    }
  }
  @media (max-width: 500px) {
    .banner {
      top: 100px;
    }
    .banner, .dates span {
      font-size: 25px;
    }
  }
</style>
